import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface KlingV26Params {
  /**
   * 视频生成提示词,最多2500字符
   * @length 0 - 2500
   */
  prompt: string;
  /**
   * 音频开关,可选值: on/off
   * @values on | off
   */
  sound?: 'on' | 'off';
  /**
   * 生成模式,V2.6仅支持pro模式
   * @values pro
   */
  mode: 'pro';
  /**
   * 视频宽高比
   * @values 16:9 | 9:16 | 1:1 | 
   */
  aspect_ratio?: '16:9' | '9:16' | '1:1' | '';
  /**
   * 视频时长(秒)
   * @values 5 | 10
   */
  duration?: '5' | '10';
  /**
   * 外部任务ID
   */
  external_task_id?: string;
}

export interface KlingV26Resource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * kling_v2_6
 *
 * <p>Kling AI V2.6 文本生成视频接口</p>
 * <p>API Documentation: <a href="https://docs.qingque.cn/d/home/eZQB6Bbl5WgW8eIVN--duPVl1?identityId=2Cn18n4EIHT">https://docs.qingque.cn/d/home/eZQB6Bbl5WgW8eIVN--duPVl1?identityId=2Cn18n4EIHT</a></p>
 * 
 *
 * @example
 * ```typescript
 * import { initSeacloud, klingV26 } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await klingV26({
 *   // 参数见 KlingV26Params 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 KlingV26Params 接口定义
 * @returns 生成的资源列表
 */
export async function klingV26(
  params: KlingV26Params,
): Promise<KlingV26Resource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'kling_v2_6',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: KlingV26Resource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
